import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, IconX, LocaleX, ResponsiveX, ZMath } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, VStack, XDiv, XIconButton, XImage, XText } from "IZOX/_X";
import _ from "lodash";
import { SysConfig } from "__SYSDefault/Config";

/**
 * @augments {Component<Props, State>}
 */
class DescSlide extends Component {

  static propTypes = {
    info: PropsType.object
  }

  static defaultProps = {
    info: {}
  }

  constructor(){
    super();
    this.state = {
      startIdx: 0
    };
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(DescSlide.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  _shift = (shift) => {
    let {info} = this.props;
    let {desc} = info ?? {};
    let length = desc?.length ?? 0;
    let {startIdx} = this.state;

    let newIdx = ZMath.Cap(startIdx + shift, 0, length - 3);
    this.setState({
      startIdx: newIdx
    });
    
  }

  _shiftM = (shift) => {
    let {info} = this.props;
    let {desc} = info ?? {};
    let length = desc?.length ?? 0;
    let {startIdx} = this.state;

    let newIdx = ZMath.Cap(startIdx + shift, 0, length - 1);
    this.setState({
      startIdx: newIdx
    });
    
  }

  renderShiftBtn(shift, disabled, iconBundle, iconName){
    return (
      <XIconButton onPress={() => this._shift(shift)} padding={8} disableOpacity={1}
        disabled={disabled}
        color={ColorX.CSS(disabled? "DisabledArrow" : "white")}
        bgColor={ColorX.CSS(disabled? "NotQuiteWhite" : "Grass")}
        >
        {IconX.Get(iconBundle, iconName, 24, ColorX.CSS(disabled? "DisabledArrow" : "white"))}
      </XIconButton>
    );
  }

  renderCard(o, i){
    let {title, content, icon} = o;
    return (
      <VStack width={406} height={442} round={20} m={5} key={i}
        style={{
          boxShadow: `1px 1px 5px 5px ${ColorX.CSS("greyOut", 0.2)}`,
          zIndex: 10
        }}
        bgColor={ColorX.CSS("pureWhite")}
        >
        <HStack height={144}>
          <XImage source={icon} width={86} height={86}/>
        </HStack>
        <HStack pV={14} pH={20} height={100} bgColor={ColorX.CSS("Leaf")}>
          <XText fontSize={24} fullWidth textAlign="|" bold 
            color={ColorX.CSS("pureWhite")}            
            style={{fontWeight: 700}}>
            {LocaleX.Parse(title)}
          </XText>
        </HStack>
        <HStack pL={20} pR={26} pT={10}>
          <XText fullWidth textAlign="[" fontSize={18} style={{fontWeight: 400}}>
            {LocaleX.Parse(content)}
          </XText>
        </HStack>
      </VStack>
    );
  }

  renderSlide(){
    let {info} = this.props;
    let {desc} = info ?? {};
    let length = desc?.length ?? 0;
    let {startIdx} = this.state;

    let leftDisabled = startIdx <= 0;
    let rightDisabled = (length - startIdx) <= 3;

    return (
      <HStack spacing={20} width={SysConfig.ContentWidth} pH={16}>
        {this.renderShiftBtn(-1, leftDisabled, "awesome", "chevron-left")}
        <HStack style={{flexGrow: 1}} spacing={16}>
          {_.map(_.range(startIdx, startIdx + 3), (o, i) => {
            if(desc?.[o]){
              return this.renderCard(desc[o], i);
            }
          })}
        </HStack>
        {this.renderShiftBtn(1, rightDisabled, "awesome", "chevron-right")}
      </HStack>
    );
  }

  renderNormal(){
    return (
      <VStack fullWidth mB={80} pB={80} style={{position: "relative"}}>
        <XDiv position="absolute" style={{top: 283, zIndex: 1}} fullWidth height={240}
          bgColor={ColorX.CSS("Grass", 0.1)}/>
        {this.renderSlide()}
      </VStack>
    );
  }

  renderCardM(o, i){
    let {title, content, icon} = o;
    return (
      <VStack width={Math.min(406, window.innerWidth * 0.7)} 
        height={442} 
        flexShrink={0} round={20} m={5} key={i}
        style={{
          boxShadow: `1px 1px 5px 5px ${ColorX.CSS("greyOut", 0.2)}`,
          zIndex: 10
        }}
        bgColor={ColorX.CSS("pureWhite")}
        >
        <HStack height={144}>
          <XImage source={icon} width={86} height={86}/>
        </HStack>
        <HStack pV={14} pH={20} height={100} bgColor={ColorX.CSS("Leaf")}>
          <XText fontSize={20} fullWidth textAlign="|" bold 
            color={ColorX.CSS("pureWhite")}            
            style={{fontWeight: 700}}>
            {LocaleX.Parse(title)}
          </XText>
        </HStack>
        <HStack pL={20} pR={26} pT={30} pB={20}>
          <XText fullWidth textAlign="|" fontSize={16} style={{fontWeight: 400}}>
            {LocaleX.Parse(content)}
          </XText>
        </HStack>
      </VStack>
    );
  }

  renderShiftBtnM(shift, disabled, iconBundle, iconName){
    return (
      <XIconButton onPress={() => this._shiftM(shift)} padding={8} disableOpacity={1} flexShrink={0}
        position="absolute" top={"40%"} zIndex={100} left={shift < 0 ? 30 : undefined} right={shift > 0 ? 30 : undefined}
        disabled={disabled} width={48} height={48}
        color={ColorX.CSS(disabled? "DisabledArrow" : "white")}
        bgColor={ColorX.CSS(disabled? "NotQuiteWhite" : "Grass")}
        >
        {IconX.Get(iconBundle, iconName, 24, ColorX.CSS(disabled? "DisabledArrow" : "white"))}
      </XIconButton>
    );
  }

  renderSlideM(){
    let {info} = this.props;
    let {desc} = info ?? {};
    let length = desc?.length ?? 0;
    let {startIdx} = this.state;

    let leftDisabled = startIdx <= 0;
    let rightDisabled = startIdx >= length - 1;

    let _cardWidth = Math.min(406, window.innerWidth * 0.7);
    let pL = (window.innerWidth - _cardWidth) / 2 - 10; // 20 is the margin between cards
    let step = _cardWidth + 20 * 2 + 10; // 20 is the margin between cards

    return (
      <HStack spacing={20} fullWidth HAlign="[">
        {this.renderShiftBtnM(-1, leftDisabled, "awesome", "chevron-left")}
        <HStack spacing={50} fitWidthToContent HAlign="[" position="relative" overflow="visible"
          pL={pL} left={-step * startIdx} positionTransition>
          {_.map(desc, (o, i) => {
            if(o){
              return this.renderCardM(o, i);
            }
          })}
        </HStack>
        {this.renderShiftBtnM(1, rightDisabled, "awesome", "chevron-right")}
      </HStack>
    );
  }

  renderMobile(){
    return (
      <VStack fullWidth mB={80} pB={80} position="relative">
        <XDiv position="absolute" style={{top: 283, zIndex: 1}} fullWidth height={240}
          bgColor={ColorX.CSS("Grass", 0.1)}/>
        {this.renderSlideM()}
      </VStack>
    );
  }

  render(){
    return ResponsiveX.Split({
      0: () => this.renderMobile(),
      1300: () => this.renderNormal()
    });
  }

}

export default observer(DescSlide);
